import "core-js/stable";
import "regenerator-runtime/runtime";

import "lazysizes/lazysizes";
import Menu from "../elements/menu/Menu.vue";
import LightBox from "../elements/lightbox/LightBox.vue";
import Vue from "vue";

import PortalVue from 'portal-vue'
Vue.use(PortalVue);

document.addEventListener('DOMContentLoaded', () => {
  let nodes = document.querySelectorAll('.js-vue');
  for (let node of nodes) {
    new Vue({
      el: node,
      components: {
        'sla-menu': Menu,
        'sla-lightbox': LightBox,
      },
    });
  }
})

import './disqus.js';
import './lightbox.js';

